import {combineReducers} from 'redux';
import Util from './util/Util';
import Subscription from './subscription/Subscription';
import Comments from './comments/Comments';
import Testimonials from './testimonials/Testimonials';

export default combineReducers({
  util: Util,
  subscription: Subscription,
  comments: Comments,
  testimonials: Testimonials,
});
